import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import API from '../api';
import moment from 'moment-timezone';
import './booking.css';
import avtar from "./../assets/images/bb-avtar.jpg";

import Cancellation from './../assets/images/clock.png';
import Secure from './../assets/images/add.png';
import Verified from './../assets/images/verified.png';
import Parking from './../assets/images/pin.png';

import add1 from './../assets/images/pin-1.png';
import phone1 from './../assets/images/phone.png';
import email1 from './../assets/images/email.png';
import hours1 from './../assets/images/clock-2.png';


import rocket from './../assets/images/rocket (2).png';
import gWhatsapp from './../assets/images/g-whatsapp.png';
import gPhone from './../assets/images/g-phone.png';
import star from './../assets/images/starMain.png';

import facebook from './../assets/images/facebook.png';
import instagram from './../assets/images/instagram.png';
import quoteImg from './../assets/images/quote.png';

function Booking() {
  /* ---- state (same) ---- */
  const [services, setServices] = useState([]);
  const [employees, setEmployees] = useState([]);          // filtered for Step 2
  const [allEmployees, setAllEmployees] = useState([]);    // for carousel + Meet Our Barbers
  const [selectedService, setSelectedService] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedTime, setSelectedTime] = useState('');
  const [userContact, setUserContact] = useState({ name: '', email: '', phone: '' });
  const [bookedSlots, setBookedSlots] = useState([]);
  const [step, setStep] = useState(1);
  const [isBooking, setIsBooking] = useState(false);


  // responsive controls — paginated reveal (6 at a time on desktop)
  const PAGE = 6;
  const [isMobile, setIsMobile] = useState(false);
  const [visibleServicesCount, setVisibleServicesCount] = useState(PAGE);
  const [visibleBarbersCount, setVisibleBarbersCount] = useState(PAGE);
  const [showAllHomeBarbers, setShowAllHomeBarbers] = useState(false);

  // state
  const [expandedServiceId, setExpandedServiceId] = useState(null);
  const [workingDays, setWorkingDays] = useState([]);
  const [workingHours, setWorkingHours] = useState({});
  const [disabledDates, setDisabledDates] = useState([]);
  const [breaks, setBreaks] = useState({});

  const [bizWorkingDays, setBizWorkingDays] = useState([]);
  const [bizWorkingHours, setBizWorkingHours] = useState({});
  const [brandName, setBrandName] = useState('Demo');
  const [businessDetail, setBusinessDetail] = useState(null);

  const [reviews, setReviews] = useState([]);
  const [shopRating, setShopRating] = useState(null);
  const [shopRatingCount, setShopRatingCount] = useState(null);

  const [tz, setTz] = useState('America/New_York');

  const { businessId: routeBusinessId } = useParams();
  const [businessId, setBusinessId] = useState(routeBusinessId || '');

  const carouselRef = useRef(null);
  const stepperRef = useRef(null);
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const emailRef = useRef(null);


  const scrollDates = (dir) => carouselRef.current?.scrollBy({ left: (dir === 'left' ? -1 : 1) * 440, behavior: 'smooth' });

  const mapAbbrevToIANA = (abbr) => ({ EST: 'America/New_York', CST: 'America/Chicago', MST: 'America/Denver', PST: 'America/Los_Angeles' })[(abbr || '').toUpperCase()] || 'America/New_York';
  const formatTime = (t) => moment.tz(`2025-01-01T${t}`, tz).format('hh:mm A');

  const buildEmbeddableMapSrc = (detail) => {
    if (!detail) return null;
    const raw = detail.addressMapUrl || '';
    if (/^https?:\/\/(www\.)?google\.[^/]+\/maps\/embed/i.test(raw)) return raw;
    if (/^https?:\/\/(www\.)?google\.[^/]+\/maps\/.*[?&]output=embed/i.test(raw)) return raw;
    const parts = [detail?.address?.line1, detail?.address?.line2, detail?.address?.city, detail?.address?.state, detail?.address?.postalCode, detail?.address?.country].filter(Boolean);
    const q = parts.join(', ') || raw; if (!q) return null;
    return `https://www.google.com/maps?q=${encodeURIComponent(q)}&output=embed`;
  };

  // Socials
  const socials = {
    facebook: businessDetail?.facebookUrl || businessDetail?.social?.facebook || "",
    instagram: businessDetail?.instagramUrl || businessDetail?.social?.instagram || "",
    twitter: businessDetail?.twitterUrl || businessDetail?.social?.twitter || businessDetail?.xUrl || "",
    tiktok: businessDetail?.tiktokUrl || businessDetail?.social?.tiktok || "",
    youtube: businessDetail?.youtubeUrl || businessDetail?.social?.youtube || "",
  };

  const getFormattedBooking = React.useCallback(() => {
    if (!selectedDate || !selectedTime) return "";
    return moment
      .tz(`${selectedDate}T${selectedTime}`, tz)
      .format("dddd, MMMM D, YYYY • h:mm A");
  }, [selectedDate, selectedTime, tz]);




  // detect mobile and control service list size
  useEffect(() => {
    const apply = () => {
      const mobile = typeof window !== 'undefined' ? window.matchMedia('(max-width: 720px)').matches : false;
      setIsMobile(mobile);
      // Mobile shows everything; desktop starts at 6 per page
      setVisibleServicesCount(mobile ? Infinity : PAGE);
      setVisibleBarbersCount(mobile ? Infinity : PAGE);
    };
    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, []);

  // scroll to the stepper
  const scrollToStepper = () => {
    const el = stepperRef.current || document.querySelector('.stepper');
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // unified service select handler
  const handleSelectService = (s, advance = true) => {
    setSelectedService(s);
    setSelectedEmployee(null);
    if (advance) setStep(2);
    if (isMobile) scrollToStepper();
  };

  /* derive business id */
  useEffect(() => {
    if (routeBusinessId) { setBusinessId(routeBusinessId); return; }
    const raw = localStorage.getItem('user');
    if (!raw) return;
    try {
      const u = JSON.parse(raw);
      if (u?.business_name) setBrandName(u.business_name);
      const id = u?.role === 'admin' ? u?.id : u?.business_id;
      if (id) setBusinessId(id);
    } catch { }
  }, [routeBusinessId]);

  /* fetch services/business/reviews */
  useEffect(() => {
    if (!businessId) return;
    API.get(`/auth/services/business/${businessId}`)
      .then(r => setServices(Array.isArray(r.data) ? r.data : [])).catch(() => setServices([]));
    API.get(`/auth/business-detail?businessId=${businessId}`)
      .then(r => {
        const d = r.data || {};
        setBusinessDetail(d);
        setTz(mapAbbrevToIANA(d?.timezone || d?.timeZone || 'EST'));
        const days = Array.isArray(d.workingDays) ? d.workingDays : [];
        const hours = (typeof d.workingHours === 'object' && d.workingHours) || {};
        setBizWorkingDays(days); setBizWorkingHours(hours);
        setDisabledDates(Array.isArray(d.disabledDates) ? d.disabledDates : []);
        if (!selectedEmployee) { setWorkingDays(days); setWorkingHours(hours); }
        if (d?.businessName) setBrandName(d.businessName);
      }).catch(() => setBusinessDetail(null));

  }, [businessId, selectedEmployee]);

  useEffect(() => {
    const googleUrl = businessDetail?.googleReviewUrl || businessDetail?.addressMapUrl;
    if (!googleUrl && !businessDetail?.businessName) return;

    API.get('/auth/google-reviews', {
      params: {
        url: googleUrl || '',
        fallbackQuery: businessDetail?.businessName || ''
      }
    })
      .then(res => {
        const data = res.data || {};
        setShopRating(data.rating ?? null);
        setShopRatingCount(data.totalReviews ?? null);
        setReviews(Array.isArray(data.reviews) ? data.reviews.slice(0, 10) : []);
      })
      .catch(() => setReviews([]));
  }, [businessDetail]);

  /* fetch ALL employees for the “Meet Our Barbers' grid and carousel */
  useEffect(() => {
    API.get(`/auth/employees/business/${businessId}`)
      .then(r => setAllEmployees(Array.isArray(r.data) ? r.data : []))
      .catch(() => setAllEmployees([]));
  }, []);

  /* STEP 2 employees (filter by selected service) */
  useEffect(() => {
    if (!selectedService) return;
    API.get('/auth/employees')
      .then(res => {
        const list = Array.isArray(res.data) ? res.data : [];
        const filtered = list.filter(emp =>
          Array.isArray(emp.services_id) &&
          emp.services_id.some(s => {
            const id = typeof s === 'object' ? s?.$oid || s?._id : s;
            return id === selectedService._id;
          })
        );
        setEmployees(filtered);
      }).catch(() => setEmployees([]));
  }, [selectedService]);

  /* slots */
  useEffect(() => {
    if (!(selectedEmployee && selectedDate)) return;
    API.get(`/auth/bookings?employeeId=${selectedEmployee._id}&date=${selectedDate}`)
      .then(r => {
        const booked = (r.data || []).map(b => moment(b.bookingDateTime).tz(tz).format('HH:mm'));
        setBookedSlots(booked);
      }).catch(() => setBookedSlots([]));
  }, [selectedEmployee, selectedDate, tz]);

  /* override hours by employee */
  useEffect(() => {
    if (!selectedEmployee) return;
    API.get(`/auth/employees/${selectedEmployee._id}`)
      .then(r => {
        const d = r.data || {};
        setDisabledDates(Array.isArray(d.disabledDates) ? d.disabledDates : []);
        setWorkingDays(Array.isArray(d.workingDays) ? d.workingDays : []);
        setWorkingHours((typeof d.workingHours === 'object' && d.workingHours) || {});
        setBreaks((typeof d.breaks === 'object' && d.breaks) || {});
      }).catch(() => {
        setDisabledDates([]); setWorkingDays(bizWorkingDays || []); setWorkingHours(bizWorkingHours || {}); setBreaks({});
      });
  }, [selectedEmployee, bizWorkingDays, bizWorkingHours]);

  /* helpers */
  const formatAddress = (a) => a && typeof a === 'object'
    ? [a.line1, a.line2, a.city, a.state, a.postalCode, a.country].filter(Boolean).join(', ')
    : null;

  /* ---------- components ---------- */

  // Barber card (reusable)
  const BarberCard = ({ emp, showButton, onSelect, selected, homepage }) => {
    const name = emp?.name || 'Marcus Johnson';
    const photo =
      emp?.imageUrl ||
      emp?.photo ||
      emp?.avatar ||
      emp?.image ||
      emp?.photoUrl ||
      emp?.profileImage ||
      null;   // ← do NOT use avtar here
    const rating = emp?.rating ?? 4.9;
    const ratingCount = emp?.ratingCount ?? 30;
    const bio = emp?.bio || 'Master barber specializing in contemporary cuts and precision fades.';

    return (
      <div className={`barber-card ${selected ? 'selected' : ''}`} onClick={() => showButton ? null : undefined}>
        <div className="barber-card-top">
          {photo
            ? <img
                src={photo}
                alt={name}
                className="barber-card-photo"
                onError={(e) => { e.target.onerror = null; e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
              />
            : null}
          <div className="barber-card-avatar" style={photo ? {display:'none'} : {}}>{name.charAt(0)}</div>
          <div>
            <h4 className="barber-card-name">{name}</h4>
            <div className="barber-card-stats">
              <span className="barber-card-stat"><img className='starImg' src={star} alt='star' /> {rating} ({ratingCount})</span>
            </div>
          </div>
        </div>
        <div className="barber-card-bio">{bio}</div>

        <button
          className="btn btn-gold"
          onClick={(e) => {
            e.stopPropagation();
            if (homepage) {
              document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
            } else {
              onSelect?.();   // booking mode → go to next step
            }
          }}
        >
          Select
        </button>

      </div>
    );
  };

  // a simple 9th “Show all …' tile for grids
  const ShowAllTile = ({ label, onClick }) => (
    <div className="card service showall-tile" onClick={onClick}>
      <div className="service-title">{label}</div>
      <div className="card-actions">
        <button className="btn btn-gold">{label}</button>
      </div>
    </div>
  );

  // Navigate to a step (backward always allowed; forward only if prerequisites met)
  const navigateToStep = (n) => {
    if (n === step) return;
    if (n < step) { setStep(n); scrollToStepper(); return; }
    if (n === 2 && selectedService) { setStep(2); scrollToStepper(); return; }
    if (n === 3 && selectedService && selectedEmployee) { setStep(3); scrollToStepper(); return; }
    if (n === 4 && selectedService && selectedEmployee && selectedDate && selectedTime) { setStep(4); scrollToStepper(); return; }
  };

  // Stepper
  const StepHeader = () => (
    <div className="stepper" ref={stepperRef}>
      {['Service', 'Barber', 'Date & Time', 'Confirm'].map((l, i) => {
        const n = i + 1;
        const isActive = step === n;
        const isDone = step > n;
        const isReachable = n < step ||
          (n === 2 && !!selectedService) ||
          (n === 3 && !!selectedService && !!selectedEmployee) ||
          (n === 4 && !!selectedService && !!selectedEmployee && !!selectedDate && !!selectedTime);
        return (
          <div
            key={l}
            className={`stepper-item ${isActive ? 'active' : isDone ? 'done' : ''} ${isReachable && !isActive ? 'stepper-nav' : ''}`}
            onClick={() => isReachable && navigateToStep(n)}
          >
            <div className="step-dot">{isDone ? '✓' : n}</div>
            <div className="step-label">{l}</div>
          </div>
        );
      })}
    </div>
  );

  // Services — paginated, 6 at a time on desktop
  const ServicesView = () => {
    const visible = services.slice(0, visibleServicesCount);
    const remaining = services.length - visible.length;
    const hasMoreServices = !isMobile && remaining !== 0;
    return (
      <>
        <div className="cards-grid">
          {visible.map(s => {
            const isSel = selectedService?._id === s._id;
            return (
              <div
                key={s._id}
                className={`card service ${isSel ? 'selected' : ''}`}
                onClick={() => {
                  if (isMobile) { handleSelectService(s, true); }
                  else { setSelectedService(s); }
                }}
              >
                <div className="service-title">{s.name || 'Classic Haircut'}</div>
                <div className="service-sub">{s.description || 'Traditional scissor cut with styling'}</div>
                <div className="service-addon">Add-ons</div>
                <div className="service-footer">
                  <div className="service-duration">{s.duration_minutes ?? 30} mins</div>
                  <div className="service-price">${s.price ?? 499}</div>
                </div>
                <div className="card-actions">
                  <button
                    className="btn btn-gold"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectService(s, true);
                      scrollToStepper();
                    }}
                  >
                    Select
                  </button>
                </div>
              </div>
            );
          })}
          {services.length === 0 && (
            <div className="empty-text">No services available</div>
          )}
        </div>
        {hasMoreServices && (
          <button
            className="btn view-more-btn"
            onClick={() => setVisibleServicesCount(c => c + PAGE)}
          >
            View More ({remaining} more service{remaining !== 1 ? 's' : ''})
          </button>
        )}
      </>
    );
  };

  // Barber selection grid (Step 2) — paginated, 6 at a time on desktop
  const BarbersView = () => {
    const visible = employees.slice(0, visibleBarbersCount);
    const remaining = employees.length - visible.length;
    const hasMoreBarbers = !isMobile && remaining !== 0;
    return (
      <>
        <div className="cards-grid">
          {visible.map(emp => {
            const isSel = selectedEmployee?._id === emp._id;
            return (
              <div key={emp._id} onClick={() => setSelectedEmployee(emp)}>
                <BarberCard
                  emp={emp}
                  showButton
                  selected={isSel}
                  onSelect={() => { setSelectedEmployee(emp); setStep(3); scrollToStepper(); }}
                />
              </div>
            );
          })}
          {employees.length === 0 && (
            <div className="empty-text">No barbers available</div>
          )}
        </div>
        {hasMoreBarbers && (
          <button
            className="btn view-more-btn"
            onClick={() => setVisibleBarbersCount(c => c + PAGE)}
          >
            View More ({remaining} more barber{remaining !== 1 ? 's' : ''})
          </button>
        )}
      </>
    );
  };

  /* ---------- Date & Time + Back/Next ---------- */
  const DateTimeView = () => (
    <>
      <div className="date-scroller">
        <button className="arrow left" onClick={() => scrollDates('left')}>&lsaquo;</button>
        <div className="dates" ref={carouselRef}>
          {Array.from({ length: 30 }).map((_, index) => {
            const date = moment().tz(tz).add(index, 'days');
            const dateStr = date.format('YYYY-MM-DD');
            const dayName = date.format('dddd');

            const isDisabled =
              !(workingDays || []).includes(dayName) ||
              (disabledDates || []).includes(dateStr);

            return (
              <button
                key={dateStr}
                className={`date-pill ${selectedDate === dateStr ? 'selected' : ''}`}
                onClick={() => { if (!isDisabled) { setSelectedDate(dateStr); setSelectedTime(''); } }}
                disabled={isDisabled}
              >
                <div className="date-pill-dow">{date.format('ddd')}</div>
                <div className="date-pill-day">{date.format('D')}</div>
                <div className="date-pill-mon">{date.format('MMM')}</div>
              </button>
            );
          })}
        </div>
        <button className="arrow right" onClick={() => scrollDates('right')}>&rsaquo;</button>
      </div>

      <div className="time-grid">
        {selectedDate && (() => {
          const dayName = moment(selectedDate).format('dddd');
          const dayHours = (workingHours && workingHours[dayName]) || {};
          const openTime = dayHours.opensAt || '09:00';
          const closeTime = dayHours.closesAt || '17:00';

          const openMoment = moment.tz(`${selectedDate}T${openTime}`, tz);
          const closeMoment = moment.tz(`${selectedDate}T${closeTime}`, tz);

          const slots = [];
          const slotDuration = 30;
          while (openMoment < closeMoment) {
            const slot = openMoment.format('HH:mm');
            slots.push(slot);
            openMoment.add(slotDuration, 'minutes');
          }

          return slots.map(time => {
            const isBooked = bookedSlots.includes(time);
            const dayBreaks = (breaks && breaks[dayName]) || [];
            const isBreak = dayBreaks.some(b => {
              const breakStart = moment(b.start, 'HH:mm');
              const breakEnd = moment(b.end, 'HH:mm');
              const slotMoment = moment(time, 'HH:mm');
              return slotMoment.isSameOrAfter(breakStart) && slotMoment.isBefore(breakEnd);
            });

            return (
              <button
                key={time}
                className={`time-btn ${selectedTime === time ? 'selected' : ''}`}
                onClick={() => setSelectedTime(time)}
                disabled={isBooked || isBreak}
              >
                {formatTime(time)}
              </button>
            );
          });
        })()}
      </div>

    </>
  );

  /* ---------- Confirm ---------- */
  const handleConfirmBooking = () => {
    if (isBooking) return;
    setIsBooking(true);
    const contact = {
      name: nameRef.current?.value.trim(),
      phone: phoneRef.current?.value.trim(),
      email: emailRef.current?.value.trim(),
    };
    if (!contact.name || !contact.phone || !contact.email) {
      setIsBooking(false);
      alert("Please fill all fields");
      return;
    }
    const bookingDateTime = moment.tz(`${selectedDate}T${selectedTime}`, tz).toISOString();
    API.post("/auth/bookings", { serviceId: selectedService._id, employeeId: selectedEmployee._id, bookingDateTime, contact })
      .then(() => {
        alert("Booking Confirmed!");
        if (nameRef.current) nameRef.current.value = "";
        if (phoneRef.current) phoneRef.current.value = "";
        if (emailRef.current) emailRef.current.value = "";
        setStep(1); setSelectedService(null); setSelectedEmployee(null);
        setSelectedDate(""); setSelectedTime("");
        scrollToStepper();
      })
      .catch((err) => { alert("Booking failed: " + (err.response?.data?.error || err.message)); })
      .finally(() => { setIsBooking(false); });
  };

  const ConfirmView = () => (
    <div className="confirm-grid">
        <div className="confirm-card">
          <div className="confirm-title">Appointment</div>
          <div className="confirm-line">
            {getFormattedBooking()}


          </div>
        </div>

        <div className="confirm-card">
          <div className="confirm-title">Service & Barber</div>
          <div className="confirm-line">{selectedService?.name || 'Service'} with {selectedEmployee?.name || 'Barber'}</div>
          <div className="confirm-total">Total: ${selectedService?.price ?? '—'}</div>
        </div>

        <div className="confirm-card">
          <div className="confirm-title">Your Details</div>

          <input
            ref={nameRef}
            name="name"
            type="text"
            className="confirm-input"
            placeholder="Full Name"
          />

          <input
            ref={phoneRef}
            name="phone"
            type="text"
            className="confirm-input"
            placeholder="Phone Number"
          />

          <input
            ref={emailRef}
            name="email"
            type="email"
            className="confirm-input"
            placeholder="Email Address"
          />
        </div>

    </div>
  );

  const display = {
    name: businessDetail?.businessName || brandName || '',
    rating: shopRating ?? null,
    totalReviews: shopRatingCount ?? null,
    address: (businessDetail?.address && formatAddress(businessDetail.address)) || businessDetail?.owner?.address || null,
    phone: businessDetail?.owner?.phone || null,
    whatsapp: businessDetail?.whatsappUrl || businessDetail?.social?.whatsapp || null,
    email: businessDetail?.businessEmail || businessDetail?.owner?.email || null,
    mapUrl: businessDetail?.addressMapUrl || null,
    googleReviewUrl: businessDetail?.googleReviewUrl || null,
    coverImageUrl: businessDetail?.coverImageUrl || null,
  };
  const weeklyHours = selectedEmployee ? workingHours : (bizWorkingHours || {});
  const hasReviews = reviews != null && reviews.length !== 0;
  // const resolvedReviews = reviews?.length ? reviews : Array.from({ length: 5 }).map((_, i) => ({
  //   _id: `demo-${i}`,
  //   author: 'Raj Patel',
  //   rating: 5,
  //   text: 'Best haircut I have had in years. Marcus really knows his craft. The attention to detail is unmatched.',
  //   timeAgo: '2 weeks ago'
  // }));

  /* layout */
  return (
    <div className="page">
      <header
        className="hero"
        style={{
          backgroundImage: display.coverImageUrl
            ? `url(${display.coverImageUrl}), url('https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=1400&auto=format&fit=crop')`
            : `url('https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=1400&auto=format&fit=crop')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center top'
        }}
      >
        <div className="hero-inner">
          <div className="hero-copy">
            <h1>{display.name || 'Business Name'}</h1>
            <p>Real-time availability • Clear pricing • Instant confirmation.</p>
            <div className="hero-ctas">
              <a href="#book" className="btn btn-gold">Book Now</a>
              <a href="#services" className="btn btn-ghost">View Services & Pricing</a>
            </div>
          </div>
        </div>
      </header>

      <main className="container">
        <section className="grid-2" id="book">
          {/* LEFT */}
          <div className="left">
            <section className="intro" id="services">
              <h2 className="intro-title">{display.name || 'Business Name'}</h2>
            </section>

            <div className="booking-card">
              {/* Fixed header: stepper + step title */}
              <div className="bcard-header">
                <StepHeader />
                <hr className="divider" />
                <div className="bcard-step-title">
                  {step === 1 && 'Services'}
                  {step === 2 && 'Select a Barber'}
                  {step === 3 && 'Choose Date & Time'}
                  {step === 4 && 'Review & Confirm'}
                </div>
              </div>

              {/* Scrollable content */}
              <div className="bcard-scroll">
                {step === 1 && <ServicesView />}
                {step === 2 && <BarbersView />}
                {step === 3 && <DateTimeView />}
                {step === 4 && <ConfirmView />}
              </div>

              {/* Fixed footer: navigation buttons */}
              <div className="bcard-footer">
                {step === 1 && (
                  <>
                    <button className="btn" disabled>Back</button>
                    <button className="btn btn-gold" onClick={() => { setStep(2); scrollToStepper(); }} disabled={!selectedService}>Next</button>
                  </>
                )}
                {step === 2 && (
                  <>
                    <button className="btn" onClick={() => { setStep(1); scrollToStepper(); }}>Back</button>
                    <button className="btn btn-gold" onClick={() => { setStep(3); scrollToStepper(); }} disabled={!selectedEmployee}>Continue</button>
                  </>
                )}
                {step === 3 && (
                  <>
                    <button className="btn" onClick={() => { setStep(2); scrollToStepper(); }}>Back</button>
                    <button className="btn btn-gold" disabled={!selectedDate || !selectedTime} onClick={() => { setStep(4); scrollToStepper(); }}>Next</button>
                  </>
                )}
                {step === 4 && (
                  <>
                    <button className="btn" onClick={() => { setStep(3); scrollToStepper(); }}>Back</button>
                    <button type="button" className="btn btn-gold" disabled={isBooking} onClick={handleConfirmBooking}>
                      {isBooking ? <><span className="loader"></span> Booking...</> : 'Confirm Booking'}
                    </button>
                  </>
                )}
              </div>
            </div>

            {/* Meet Our Barbers — below Services section */}
            <section className="barbers-section">
              <h3 className="section-title">Meet Our Barbers</h3>
              <div className="cards-grid">
                {(showAllHomeBarbers ? allEmployees : allEmployees.slice(0, 8)).map(emp => (
                  <BarberCard
                    key={emp._id}
                    emp={emp}
                    showButton={true}
                    homepage={true}
                  />
                ))}
                {!showAllHomeBarbers && allEmployees.length > 8 && (
                  <ShowAllTile label="Show all barbers" onClick={() => setShowAllHomeBarbers(true)} />
                )}
                {allEmployees.length === 0 && <BarberCard emp={{ name: 'Marcus Johnson' }} showButton={true} homepage={true} />}
              </div>
            </section>

          </div>

          {/* RIGHT — Sidebar card that matches your reference */}
          <aside className="right">
            <div className="shop-card">
              {(() => {
                const embedSrc = buildEmbeddableMapSrc(businessDetail);
                return (
                  <div className="map-banner">
                    {embedSrc ? (
                      <iframe
                        title="Business Location"
                        src={embedSrc}
                        style={{ width: '100%', height: 220, border: 0, borderRadius: 12 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      />
                    ) : (
                      <div className="map-placeholder">
                        <div className="map-dot" />
                        <span>Map</span>
                      </div>
                    )}
                    {/* overlay like the screenshot */}
                    <div className="map-overlay">
                      <div>
                        <div className="overlay-title">{display.name || 'Barber Shop'}</div>
                        {display.address && <div className="overlay-sub"><img src={add1} alt="add1" /> {display.address}</div>}
                      </div>
                      <a href="#book" className="overlay-cta" title="Book">
                        <img src={rocket} alt="rocket" />
                      </a>
                    </div>
                  </div>
                );
              })()}

              {(display.rating !== null || display.totalReviews !== null) && (
                <div className="shop-meta">
                  <div className="shop-title">Rating</div>
                  <div className="shop-rating">
                    <span className="star-number">{display.rating ?? '—'} </span> {display.totalReviews !== null ? `${display.totalReviews} Reviews` : ''}
                    <div className='stars-box'>
                      <img className='starImg' src={star} alt='star' />
                      <img className='starImg' src={star} alt='star' />
                      <img className='starImg' src={star} alt='star' />
                      <img className='starImg' src={star} alt='star' />
                      <img className='starImg' src={star} alt='star' />
                    </div>
                  </div>
                </div>
              )}
              {(display.phone || display.whatsapp) && (
                <>
                  <div className="shop-title">Contact</div>
                  <div className="contact-row">
                    {display.phone && <a href={`tel:${display.phone}`} className="btn btn-ghost btn-half"><img src={gPhone} alt="phone" />  {display.phone}</a>}
                    {display.whatsapp && <a href={display.whatsapp} target="_blank" rel="noreferrer" className="btn btn-ghost btn-half"><img src={gWhatsapp} alt="whatsapp" />  Chat on WhatsApp</a>}
                  </div>
                </>
              )}



              <div className="hours">
                <div className="shop-title">Hours</div>
                <div className="hours-grid">
                  {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(d => {
                    const h = weeklyHours?.[d];
                    const value = h
                      ? (h.closed
                        ? 'Closed'
                        : `${moment.tz(`2025-01-01T${h.opensAt || '09:00'}`, tz).format('h:mm A z')} – 
         ${moment.tz(`2025-01-01T${h.closesAt || '18:00'}`, tz).format('h:mm A z')}`
                      )
                      : '—';

                    return (<React.Fragment key={`hours-${d}`}><div>{d}</div><div className={h?.closed ? 'visitus-closed' : ''}>{value}</div></React.Fragment>);
                  })}
                </div>
              </div>

              {/* {display.googleReviewUrl && (
                <div className="btn-row">
                  <a href={display.googleReviewUrl} className="btn btn-ghost btn-full" target="_blank" rel="noreferrer">
                    View Google Reviews
                  </a>
                </div>
              )} */}

              <div className="shop-title">Social Media</div>

              {/* Socials row */}
              {(socials.facebook || socials.instagram || socials.twitter || socials.tiktok || socials.youtube) && (
                <div className="social-row">
                  {socials.instagram && <a className="social-icon ig" href={socials.instagram} target="_blank" rel="noreferrer" aria-label="Instagram"><img src={instagram} alt='instagram' /></a>}
                  {socials.facebook && <a className="social-icon fb" href={socials.facebook} target="_blank" rel="noreferrer" aria-label="Facebook"><img src={facebook} alt='fb' /></a>}
                  {/* {socials.twitter && <a className="social-icon tw" href={socials.twitter} target="_blank" rel="noreferrer" aria-label="X">x</a>}
                  {socials.tiktok && <a className="social-icon tt" href={socials.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok">♫</a>}
                  {socials.youtube && <a className="social-icon yt" href={socials.youtube} target="_blank" rel="noreferrer" aria-label="YouTube">▶</a>} */}
                </div>
              )}

              <div className="btn-row">
                <a href="#book" className="btn btn-gold btn-full">Book Your Cut</a>
              </div>
            </div>
          </aside>
        </section>



        {/* Reviews — only render when there are actual reviews */}
        {hasReviews && (
          <section className='reviews-section' id='reviews'>
            <div className='reviews-head'>
              <h3 className='section-title'>Reviews</h3>
              <div className='reviews-rating'>
                <span className='star-number'>
                  <img className='starImg' src={star} alt='star' />
                  <img className='starImg' src={star} alt='star' />
                  <img className='starImg' src={star} alt='star' />
                  <img className='starImg' src={star} alt='star' />
                  <img className='starImg' src={star} alt='star' />
                  &nbsp;{display.rating ?? '—'}
                </span>
                {display.totalReviews !== null && <span>&nbsp;{display.totalReviews} Reviews</span>}
              </div>
            </div>

            <div className='reviews-list'>
              {reviews.map((r, i) => (
                <div key={r.time || i} className='review-card'>
                  <img className='quoteImg' src={quoteImg} alt='quoteImg' />
                  <div className='review-stars'>
                    <img className='starImg' src={star} alt='star' />
                    <img className='starImg' src={star} alt='star' />
                    <img className='starImg' src={star} alt='star' />
                    <img className='starImg' src={star} alt='star' />
                    <img className='starImg' src={star} alt='star' />
                  </div>
                  <p className='review-text'>'{r.text || 'No review text'}'</p>
                  <div className='review-author'>
                    <div className='avatar sm'>{(r.author_name || 'A')[0]}</div>
                    <div>
                      <div className='name'>{r.author_name || 'Anonymous'}</div>
                      <div className='ago'>{r.relative_time_description || ''}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Visit Us */}
        <section className="visit-section" id="visit">
          <h3 className="section-title centered">Visit Us</h3>
          <p className="visit-sub centered">Premium grooming in a convenient location</p>

          <div className="visitus-grid">
            <div className="visitus-card">
              <h3 className="visitus-card-title">Visit Us</h3>
              <div className="visitus-block">
                <div className="visitus-title">
                  <img className="visitus-icon" src={add1} alt="" />
                  <div className="box">
                    <span>Address</span>
                    <div className="visitus-line">{display.address || '—'}</div>
                    {display.mapUrl && (
                      <div className="visitus-line">
                        <a href={display.mapUrl} target="_blank" rel="noreferrer">Open in Maps</a>
                      </div>
                    )}
                  </div>
                </div>

              </div>


              <div className="visitus-block">
                <div className="visitus-title">
                  <img className="visitus-icon" src={phone1} alt="" />

                  <div className="box">
                    <span>Phone</span>
                    <div className="visitus-line"><a href={`tel:${display.phone || ''}`}>{display.phone || '—'}</a></div>
                    <div className="visitus-line">
                      <a className="visitus-wa-link" href={display.whatsapp || '#'} target="_blank" rel="noreferrer">Chat on WhatsApp</a>
                    </div>
                  </div>
                </div>

              </div>

              <div className="visitus-block">
                <div className="visitus-title">
                  <img className="visitus-icon" src={email1} alt="" />
                  <div className="box">
                    <span>Email</span>
                    <div className="visitus-line"><a href={`mailto:${display.email || ''}`}>{display.email || '—'}</a></div>

                  </div>


                </div>
              </div>

              <div className="visitus-block">
                <div className="visitus-title">
                  <img className="visitus-icon" src={hours1} alt="" />
                  <div className="box">
                    <span>Hours</span>
                    <div className="visitus-hours-grid">
                      {['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'].map(d => {
                        const h = weeklyHours?.[d];
                        const value = h
                          ? (h.closed
                            ? 'Closed'
                            : `${moment.tz(`2025-01-01T${h.opensAt || '09:00'}`, tz).format('h:mm A z')} – 
         ${moment.tz(`2025-01-01T${h.closesAt || '18:00'}`, tz).format('h:mm A z')}`
                          )
                          : '—';

                        return (<React.Fragment key={`visitus-${d}`}><div>{d}</div><div className={h?.closed ? 'visitus-closed' : ''}>{value}</div></React.Fragment>);
                      })}
                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div className="visitus-map">
              {(() => {
                const embedSrc = buildEmbeddableMapSrc(businessDetail);
                return embedSrc ? (
                  <iframe
                    title="Business Map"
                    src={embedSrc}
                    style={{ width: '100%', height: 350, border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                ) : (
                  <div className="visitus-map-placeholder">
                    <div className="visitus-map-dot" />
                    <span>Map</span>
                  </div>
                );
              })()}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="features">
          <div className="feature-pill"><img src={Secure} alt="" /> Secure Payments</div>
          <div className="feature-pill"><img src={Verified} alt="" /> Verified Reviews</div>
          <div className="feature-pill"><img src={Parking} alt="" /> Free Parking</div>
          <div className="feature-pill"><img src={Cancellation} alt="" /> Flexible Cancellation</div>
        </section>

      </main>

      <footer className="cta-footer">
        <div className="cta-inner">
          <h2>Ready when you are</h2>
          <p>Book your appointment in under a minute</p>
          <a href="#book" className="btn btn-gold">Book Your Cut</a>
          <small className="tiny-note">No credit card required • Instant confirmation • Easy cancellation</small>
        </div>
        <div className="legal">© {new Date().getFullYear()} {display.name || 'Business'}. All rights reserved.</div>
      </footer>
    </div>
    
  );
}

export default Booking;
